/*
 * Cookievore — Halloween gift auto-add (code EYES)
 *
 * Adds 1 "Monster Cookie Pack" to the cart as a gift once the cart reaches EGP 600
 * (everything the customer is buying; the gift itself never counts) AND the customer is
 * carrying the code EYES in their session (typed at checkout/cart or via /discount/EYES).
 * Fatima, 22 Oct 2026: the bar is EGP 600, "a little over" the average web order.
 *
 * The 100% discount is applied by the Shopify code discount
 * "Halloween gift: Monster Cookie Pack" (Buy-X-Get-Y, code EYES, EGP 600 minimum spend).
 * This script ONLY puts the pack in the cart, and pulls it back out the moment it
 * would not be discounted. It can never sell the pack at the wrong price.
 *
 * Adapted from lydia-gift.js (LYDIA10-26, live-tested 2026-09-26): same guards —
 * pull the gift when the cart stops qualifying, never force it back after the
 * customer removes it, only ever touch the line we added, and verify the discount
 * actually landed (summed across every pack line, not just ours).
 *
 * Toggle off with settings.eyes_gift_enabled = false in settings_data.json.
 */
(function () {
  'use strict';

  var CFG = {
    code: 'EYES',
    giftVariantId: 50537886285962,          // Monster Cookie Pack (CB2C01-016)
    giftName: 'Monster Cookie Pack',
    giftWorth: 'EGP 120',
    giftUnitPrice: 12000,                    // piastres — what one gift must be discounted by
    threshold: 60000,                        // piastres = EGP 600.00, the discount's minimum spend
    // must match the discount's window (22 Oct 2026 00:00 -> 31 Oct 2026 23:59 Cairo)
    startsAt: '2026-10-21T21:00:00Z',
    endsAt: '2026-10-31T21:59:59Z',
    prop: '_free_gift'
  };

  var running = false;
  var ADDED_KEY = 'cv_eyes_added';
  var DECLINED_KEY = 'cv_eyes_declined';
  var BLOCKED_KEY = 'cv_eyes_blocked';

  function store(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }

  function notStarted() { return Date.now() < Date.parse(CFG.startsAt); }
  function expired() { return Date.now() > Date.parse(CFG.endsAt); }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function addGift() {
    var body = { id: CFG.giftVariantId, quantity: 1, properties: {} };
    body.properties[CFG.prop] = 'Our gift to you';
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function setLineQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* The code rides in the session once /discount/EYES is hit or the code is typed at the cart. Ignore `applicable` — it stays
     false until the entitled product is in the cart, which is what we're about to do. */
  function hasCode(cart) {
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if (String(codes[i].code || '').toUpperCase() === CFG.code) return true;
    }
    return false;
  }

  /* Only ever touch a line WE added — never a box the customer chose to pay for. */
  function findGiftLine(items) {
    return items.filter(function (i) {
      return i.variant_id === CFG.giftVariantId && i.properties && i.properties[CFG.prop];
    })[0];
  }

  /* Qualifying spend = everything the customer is actually BUYING, pre-discount.
     Only the line we added is left out. Mirrors the discount's qualifying
     collection "Gift Qualifying Spend (all products)". */
  function qualifyingSpend(items) {
    return items.reduce(function (sum, i) {
      var ours = i.variant_id === CFG.giftVariantId && i.properties && i.properties[CFG.prop];
      return ours ? sum : sum + i.original_line_price;
    }, 0);
  }

  /* Did one pack's worth of discount actually land? Shopify allocates the BXGY to
     whichever pack line it likes (with a paid pack in the cart it may zero THAT one),
     so check the total allocated to our code across every pack line, NOT whether
     our own line reads zero. */
  function giftDiscountLanded(items) {
    var allocated = 0;
    items.forEach(function (i) {
      if (i.variant_id !== CFG.giftVariantId) return;
      (i.line_level_discount_allocations || []).forEach(function (a) {
        var title = a.discount_application && a.discount_application.title;
        if (String(title || '').toUpperCase() === CFG.code) allocated += a.amount;
      });
    });
    return allocated >= CFG.giftUnitPrice;
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    if (/\/cart/.test(window.location.pathname)) window.location.reload();
  }

  function toast(msg) {
    var el = document.getElementById('cv-eyes-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'cv-eyes-toast';
      el.setAttribute('role', 'status');
      el.style.cssText =
        'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#1a1a1a;' +
        'color:#fff;padding:13px 22px;border-radius:8px;font-size:14px;line-height:1.4;' +
        'z-index:99999;box-shadow:0 4px 16px rgba(0,0,0,.25);transition:opacity .3s;' +
        'max-width:92vw;text-align:center';
      document.body.appendChild(el);
    }
    el.innerHTML = msg;
    el.style.opacity = '1';
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.style.opacity = '0'; }, 6000);
  }

  function dropGift(gift, msg) {
    return setLineQty(gift.key, 0).then(function () {
      store(ADDED_KEY, '');
      if (msg) toast(msg);
      refreshCartUI();
    });
  }

  /* Belt and braces: if no box came back discounted, the code did not actually
     apply (used up, per-customer limit, expired, knocked out by another discount).
     Re-read once before acting, then pull our line so nothing is overcharged. */
  function verifyPrice() {
    return new Promise(function (resolve) { setTimeout(resolve, 900); })
      .then(getCart)
      .then(function (cart) {
        var gift = findGiftLine(cart.items);
        if (!gift || giftDiscountLanded(cart.items)) return;
        store(BLOCKED_KEY, '1');
        return dropGift(gift,
          'Your gift code could not be applied, so the <strong>' + CFG.giftName +
          '</strong> was removed. You have not been charged for it.');
      })
      .catch(function () {});
  }

  function sync() {
    if (running) return;
    running = true;
    getCart()
      .then(function (cart) {
        var gift = findGiftLine(cart.items);
        var qualifies = hasCode(cart) &&
                        qualifyingSpend(cart.items) >= CFG.threshold &&
                        !notStarted() && !expired();

        /* 1. No longer qualifying -> pull our gift back out.
              Without this the discount stops applying and the customer is
              silently charged the full EGP 120 for it. */
        if (gift && !qualifies) {
          var why = expired() || notStarted()
            ? 'This gift offer is not running, so the <strong>' + CFG.giftName + '</strong> was removed.'
            : 'Spend EGP 600 or more to claim your <strong>' + CFG.giftName +
              '</strong> gift. It has been removed for now.';
          return dropGift(gift, why);
        }

        /* 2. Never more than one gift. */
        if (gift && gift.quantity > 1) {
          return setLineQty(gift.key, 1).then(refreshCartUI);
        }

        /* 3. Gift present and qualifying -> make sure it really came through at zero. */
        if (gift) return verifyPrice();

        if (!qualifies) return;

        /* 4. Customer removed the gift themselves -> respect it, don't force it back. */
        if (read(ADDED_KEY) === '1') { store(DECLINED_KEY, '1'); return; }
        if (read(DECLINED_KEY) === '1' || read(BLOCKED_KEY) === '1') return;

        /* 5. Qualifying and code in hand -> add the gift, even if they are already
              buying a pack themselves: theirs is paid, ours is the gift. */
        return addGift().then(function () {
          store(ADDED_KEY, '1');
          toast('&#127873; Added as our gift: <strong>' + CFG.giftName +
                '</strong>, worth ' + CFG.giftWorth + '.');
          refreshCartUI();
          return verifyPrice();
        });
      })
      .catch(function () {})
      .then(function () { running = false; });
  }

  document.addEventListener('cart:item-added', sync);
  document.addEventListener('cart:updated', sync);

  /* Kalles posts cart changes over fetch/XHR — watch both so the drawer stays in step. */
  var _fetch = window.fetch;
  window.fetch = function (url) {
    var res = _fetch.apply(this, arguments);
    var u = typeof url === 'string' ? url : (url && url.url) || '';
    if (u.indexOf('/cart/add') !== -1 || u.indexOf('/cart/change') !== -1 || u.indexOf('/cart/update') !== -1) {
      res.then(function (r) { if (r.ok) setTimeout(sync, 350); return r; }).catch(function () {});
    }
    return res;
  };

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (typeof u === 'string' && (u.indexOf('/cart/add') !== -1 || u.indexOf('/cart/change') !== -1 || u.indexOf('/cart/update') !== -1)) {
      this.addEventListener('load', function () { setTimeout(sync, 350); });
    }
    return _open.apply(this, arguments);
  };

  if (document.readyState === 'complete') sync();
  else window.addEventListener('load', sync);
})();
